var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailArticle',{attrs:{"item":_vm.faq.data,"schemaType":"DigitalDocument"}},[_c('p',[_vm._v(_vm._s(_vm.faq.data.question))]),_c('p',[_vm._v(_vm._s(_vm.faq.data.answer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }